import styled from 'styled-components';

export default styled.div`
  border: 1px solid #eaeaea;
  border-radius: 10px;
  padding: 30px;
`;
